import React from "react";
// import "./threeD.css";

import satelliteImage from "./satellite.jfif";

const ThreeD = (props) => {
  const x = props.angle;
  const styles = { 
      transform: `rotateY(${x}deg)` 
  };
  return (
    <div>
      <div style={{ perspective: "1200px" }}>
        <img
          className="satellite-rotate"
          src={satelliteImage}
          alt="Satellite"
          style = {styles}
        />
      </div>
    </div>
  );
};

export default ThreeD;

// import React from "react";

// const ThreeD = () => {
//   return (
//     <div>
//       <iframe
//         src="https://solarsystem.nasa.gov/gltf_embed/2378"
//         style={{ height: "200px", width: "300px" }}
//         title="Iframe Example"
//       ></iframe>
//     </div>
//   );
// };

// export default ThreeD;
